export const createEmptyMeeting = () => {
  return {
    id: `meeting-${Date.now()}`,
    name: '',
    link: '',
    address: null,
    date: null,
    time: null,
  };
};

export const createEmptySpeaker = () => {
  return {
    id: `speaker-${Date.now()}`,
    name: null,
    title: null,
    bio: null,
    image: null,
  };
};
